export default {
	data() {
		return {
			wikidataUrl: process.env.MIX_WIKIDATA_URL,
			mostUsedTags: [],
			recentlyUsedTags: [],
		}
	},
	methods: {
		getMostUsedTags(taggableType) {
			axios.get('/' + taggableType + '/mostUsedTags').then(response => {
				this.mostUsedTags = response.data;
			}).catch(err => {
				console.log(err)
			})
		},
		getRecentlyUsedTags(taggableType) {
			axios.get('/' + taggableType + '/recentlyUsedTags').then(response => {
				this.recentlyUsedTags = response.data;
			}).catch(err => {
				console.log(err)
			})
		},
	}
};